import { ArrowBack, DeleteOutlined, SaveOutlined } from "@mui/icons-material";
import { Box, Checkbox, Divider, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import { ChevronLeft, ChevronRight, Eye, Info } from "lucide-react";
import { useEffect, useMemo, useRef, useState } from "react";
import { Controller, useForm, useWatch } from "react-hook-form";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTheme } from "styled-components";
import { Button, IconInfo, Loading } from "../../../components";
import { fetchTextoPadrao } from "../../../services";
import { useToastStore, useUserStore } from "../../../stores";
import { colorBgNegative, colorCR5, colorNegative, colorPrimary, colorSubText, textFieldStyle } from "../../../theme";
import { formatCurrencyBRL, formatDateFromISO, formatHourFromISO, maskCurrencyBRL, mergeDateAndHour } from "../../../utils/mask/MaskUtils";
import { AdDetailsModal } from "../components/AdDetailsModal";
import { AutoCompleteField } from "../components/AutoComplete";
import { SubmitButton } from "../components/ButtonComponent";
import { NewVehicleBox } from "../components/NewVehicleBoxComponent";
import { cellStyle } from "../components/TableColor";
import { TextFieldController } from "../components/TextFieldComponent";
import { CompanyDTO, NovoAnuncioComboDTO, NovoComboAnuncioFormDTO, VehiclePackage } from "../dto/CompanyDTO";
import { formatCurrency, parseCurrency } from "../helpers/ComapnyHelpers";
import { criarAnuncioCombo, fetchAdForPackage, fetchComboAnuncioById, fetchCompanies, putDesativaAnuncioCombo, putPublicaAnuncioCombo, renovaAnuncioCombo, upadteAnuncioCombo } from "../repository/ComapnyRepository";


export function NewAdPackage() {
const { user } = useUserStore();
const {adId} = useParams();
const isEdit = adId !==undefined && adId !== null;
const navigate = useNavigate();
const theme = useTheme();
const { setToast } = useToastStore();
const jaCarregouRef = useRef(false);
const skipTextoPadraoRef = useRef(false);
const [loading, setLoading] = useState(false);
const [selectedAdId, setSelectedAdId] = useState<number | null>(null);
const [isLeilao, setLeilao] = useState<boolean>(true);
const [companies, setCompanies]= useState<CompanyDTO [] | null>(null);
const [veiculos, setVeiculos] = useState<VehiclePackage[]>([]);
const [veiculosSelecionados, setVeiculosSelecionados] = useState<VehiclePackage[]>([]);
const rowsPerPage = 5;
const [search, setSearch] = useState("");
const [page, setPage] = useState(0);
const allowsEdit =
  !veiculosSelecionados ||
  !veiculosSelecionados.some((v) => v.id === selectedAdId);
  const [status, setStatus] = useState<string>("");
  const [ativo, setAtivo] = useState<string>("");
 const {
  control,
  handleSubmit,
  formState: { errors },
  reset,
  setValue,
  setFocus
} = useForm<NovoComboAnuncioFormDTO>({ defaultValues: {
  id_concessionaria_anunciante: 0,
  val_inicial: '',
  val_compre_agora: '',
  horario_finalizacao_leilao: '',
  data_finalizacao_leilao: '',
  horario_finalizacao_anuncio: '',
  data_finalizacao_anuncio: '',
  texto_padrao: '',
    },});

  const selectedCompany= useWatch({
  control,
  name: "id_concessionaria_anunciante",
  });

const valTotal = useMemo(() => {
  return veiculosSelecionados.reduce((total, item) => {
    return total + (parseFloat(item.val_inicial?.toString() ?? '0') ?? 0);
  }, 0);
}, [veiculosSelecionados]);

const veiculosFiltrados = useMemo(() => {
  if (!search.trim()) return veiculos;

  const termo = search.toLowerCase();

  return veiculos.filter((v) =>
    v.modelo?.toLowerCase().includes(termo)
  );
}, [veiculos, search]);
const totalPages = Math.ceil(veiculosFiltrados.length / rowsPerPage);

const veiculosPaginados = veiculosFiltrados.slice(
  page * rowsPerPage,
  page * rowsPerPage + rowsPerPage
);

const start = page * rowsPerPage + 1;

const end = Math.min(
  (page + 1) * rowsPerPage,
  veiculosFiltrados.length
);

const isSelecionado = (id: number) =>
  veiculosSelecionados.some(v => v.id === id);

const toggleSelecionado = (veiculo: VehiclePackage) => {
  setVeiculosSelecionados(prev => {
    const exists = prev.some(v => v.id === veiculo.id);

    if (exists) {
      return prev.filter(v => v.id !== veiculo.id);
    }

    return [...prev, veiculo];
  });
};

const fetchAdsForPackages = async (id_concessionaria: number) => {
    setLoading(true);
    setSelectedAdId(null);
    const userId = user?.id;
    try {
        const result = await fetchAdForPackage( userId!, id_concessionaria);
        if (!result?.success) {
            setToast({variant:"error", message:"Erro ao remover imagem"});
            return;
        }
        setVeiculos(result.data);
    } catch (error: any) {
        setToast({variant:"error", message:"Erro. Por favor contate o Administrador."}); 
    }finally{
        setLoading(false);
    }
}

const fetchCompanie = async () => {
  try {
    const userId = user?.id;
    const result = await fetchCompanies(userId);
    if (!result?.success) {
      return;
    }
    setCompanies(result.data);
  } catch (error) {
  }
}

const getTextPadrao = async(concessionaria_id: number) => {
  try {
    setLoading(true);
    const userId = user?.id;
    const result = await fetchTextoPadrao(userId!,concessionaria_id );
    if (!result?.success) {
         setToast({variant:"error", message:result?.message ?? "Erro em buscar o texto padrão."});
      return;
    }
    setValue("texto_padrao", result.data);
  } catch (error) {
    setToast({variant:"error", message:"Erro em buscar o texto padrão"});
      return;
  } finally {
    setLoading(false);
  }
};



const submitPublicaCombo = async ()=>{
try {
    setLoading(true);
    const result = await putPublicaAnuncioCombo(Number(adId));
    if(!result?.success) {
        setToast({variant:"error", message:result.message});
        return;
    }
    setToast({variant:"success", message:result.message});
    navigate('/anuncios');
} catch (error) {
    setToast({variant:"error", message:"Erro. Contate o administrador"});
} finally {
    setLoading(false);
}

};

const submitDesativaCombo = async ()=>{
    try {
    setLoading(true);
    const result = await putDesativaAnuncioCombo(Number(adId));
    if(!result?.success) {
        setToast({variant:"error", message:result.message});
        return;
    }
    setToast({variant:"success", message:result.message});
    navigate('/anuncios');
} catch (error) {
    setToast({variant:"error", message:"Erro. Contate o administrador"});
} finally {
    setLoading(false);
}
};

const preLoadData = async () => {
    try {
        setLoading(true);
        const result = await fetchComboAnuncioById(Number(adId));
        if (!result?.success) {
            setToast({variant:"error", message: result.message});
            return;
        }
        const data = result.data;
        setLeilao(data.tipo_anuncio === "L");
        const veiculosMapeados: VehiclePackage[] = (data.veiculos ?? []).map((v: any) => ({
            ...v,
            val_inicial: v.val_inicial ?? v.valor_inicial,
        }));
        setVeiculosSelecionados(veiculosMapeados);
        setAtivo(data.tag_ativo);
        setStatus(data.tag_status);
        skipTextoPadraoRef.current = true;
        reset({
            data_finalizacao_anuncio:  formatDateFromISO(data.data_finalizacao),
            data_finalizacao_leilao: formatDateFromISO(data.data_leilao),
            horario_finalizacao_anuncio:formatHourFromISO(data.data_finalizacao),
            horario_finalizacao_leilao: formatHourFromISO(data.data_leilao),
            id_concessionaria_anunciante: data.id_concessionaria,
            texto_padrao: data.texto_padrao,
            val_compre_agora: formatCurrency(data.val_compre_agora),
            val_inicial: formatCurrency(data.val_inicial),
        });
    } catch (error) {
         setToast({variant:"error", message: "Erro. Contate o administrador"});
    } finally {
        setLoading(false);
    }
};

const handleNewVehicle = () => {
navigate("/veiculo/novo")
};

const onSubmitSalvar = async (data: NovoComboAnuncioFormDTO) =>{
    if (veiculosSelecionados.length  === 0) return;
    if(data.data_finalizacao_leilao !== null &&  new Date(data.data_finalizacao_anuncio!) < new Date(data.data_finalizacao_leilao!)) {
        setToast({variant:"error", message:"A data de finalização do anúncio deve ser maior que a data de finalização do leilão"});
        return;
    }
    if(data.val_compre_agora !== null && parseCurrency(data.val_compre_agora??'0') <= parseCurrency(data.val_inicial??'0')) {
        setToast({variant:"error", message:"O valor de compra agora deve ser maior que o valor inicial"});
        return;
    }
    if(data.val_inicial !== null && parseCurrency(data.val_inicial??'0') <= 0) {
        setToast({variant:"error", message:"O valor inicial deve ser maior que 0"});
        return;
    }
    if(data.val_compre_agora !== null && parseCurrency(data.val_compre_agora??'0') <= 0) {
        setToast({variant:"error", message:"O valor de compra agora deve ser maior que 0"});
        return;
    }
    if(data.texto_padrao !== null && data.texto_padrao?.trim() === '') {
        setToast({variant:"error", message:"O texto padrão deve ser preenchido"});
        return;
    }
    if(data.id_concessionaria_anunciante !== null && data.id_concessionaria_anunciante === 0) {
        setToast({variant:"error", message:"A concessionária anunciante deve ser selecionada"});
        return;
    }
    try {
        setLoading(true);
        const payload: NovoAnuncioComboDTO = {
            data_finalizacao: mergeDateAndHour(data.data_finalizacao_anuncio!, data.horario_finalizacao_anuncio!) ?? "",
            data_leilao: data.data_finalizacao_leilao !=null ? mergeDateAndHour(data.data_finalizacao_leilao!, data.horario_finalizacao_leilao) : null,
            id_concessionaria: data.id_concessionaria_anunciante!,
            texto_padrao:data.texto_padrao?.trim() ?? null, 
            tipo_anuncio:isLeilao? "L" : "N", 
            val_compre_agora: parseCurrency(data.val_compre_agora??'0'),
            val_inicial:parseCurrency(data.val_inicial??'0'),
            veiculos:veiculosSelecionados.map((v) => v.id),
        };
    const result = isEdit? await upadteAnuncioCombo(payload, Number(adId)) : await criarAnuncioCombo(payload);
    if (!result?.success) {
        setToast({variant:"error", message:result.message});
      return;
    }
    if (result?.success) {
        navigate('/anuncios');
           setToast({variant:"success", message:result.message});
    }
    } catch (error) {
         setToast({variant:"error", message:"Erro. Contate o Administrador."});
    } finally {
        setLoading(false);
    }
};

const submitRenewAnuncioCombo = async (data: NovoComboAnuncioFormDTO) =>{
    if(!adId) return;
    if (veiculosSelecionados.length  === 0) return;
    if(data.data_finalizacao_leilao !== null &&  new Date(data.data_finalizacao_anuncio!) < new Date(data.data_finalizacao_leilao!)) {
        setToast({variant:"error", message:"A data de finalização do anúncio deve ser maior que a data de finalização do leilão"});
        return;
    }
    try {
        setLoading(true);
        const payload: NovoAnuncioComboDTO = {
            data_finalizacao: mergeDateAndHour(data.data_finalizacao_anuncio!, data.horario_finalizacao_anuncio!) ?? "",
            data_leilao: mergeDateAndHour(data.data_finalizacao_leilao!, data.horario_finalizacao_leilao)??"",
            id_concessionaria: data.id_concessionaria_anunciante!,
            texto_padrao:data.texto_padrao?.trim() ?? null, 
            tipo_anuncio:isLeilao? "L" : "N", 
            val_compre_agora: parseCurrency(data.val_compre_agora??'0'),
            val_inicial:parseCurrency(data.val_inicial??'0'),
            veiculos:veiculosSelecionados.map((v) => v.id),
        };
    const result = await renovaAnuncioCombo(payload, Number(adId));
    if (!result?.success) {
        setToast({variant:"error", message:result.message});
      return;
    }
    if (result?.success) {
        navigate('/anuncios');
           setToast({variant:"success", message:result.message});
    }
    } catch (error) {
         setToast({variant:"error", message:"Erro. Contate o Administrador."});
    } finally {
        setLoading(false);
    }
};



useEffect(() => {
  if (jaCarregouRef.current) return;
  jaCarregouRef.current = true;
  fetchCompanie();
}, []);

useEffect(() => {
    setValue("val_inicial", formatCurrencyBRL(valTotal),{
    shouldValidate: true,
    shouldDirty: true,
  });
}, [valTotal, setValue]);

useEffect(()=>{
if(!selectedCompany) return;
fetchAdsForPackages(selectedCompany);
},[selectedCompany]);

useEffect(() => {
  setPage(0);
}, [search]);

useEffect(() => {
  if (!selectedCompany) return;
  if (skipTextoPadraoRef.current) {
    skipTextoPadraoRef.current = false;
    return;
  }
  getTextPadrao(selectedCompany);
}, [selectedCompany]);

useEffect(()=> {
   if (isEdit) {
    preLoadData();
   }
},[]); 

 
if (loading) {
    return <Loading fullScreen= {true}></Loading>
  }


    return (
        <>
        <AdDetailsModal
        adId={selectedAdId ?? 0}
        open={Boolean(selectedAdId)}
        onClose={() => setSelectedAdId(null)}
        onSuccessEdit={
        async ()=> {
            if(!selectedCompany) return;
            await  fetchAdsForPackages(selectedCompany)
        }}
        allowsEdit= {allowsEdit}
        />
        <Box
              minHeight={0}
              height="100vdh"
              width="100vw"
              display="flex"
              flexDirection="column"
            >
            <Link to="/anuncios">
                <Button variant="text">
                    <ArrowBack fontSize="inherit" />
                    <span>Voltar para a listagem de anúncios</span>
                </Button>
            </Link>
            <Typography fontWeight={"bold"} fontSize={"1.4rem"} mt={3} >Novo combo de anúncios </Typography>
            <Typography fontWeight={"bold"} fontSize={"1.2rem"} mt={3} >Veículos no pacote </Typography>
            <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
            <Box
            display="grid"
            gridTemplateColumns="repeat(2, 1fr)"
            gap={4}
            width="100%"
            >
            {/*Container a esquerda de veículos selecionados */}
            <Box
            display="flex"
            minHeight={400}
            maxHeight={600}
            width="100%"
            sx={{
                p: 2,
                overflowY: "auto",
            }}
            >
            {veiculosSelecionados.length === 0 ? (
            <Box display={"flex"} flexDirection={"column"} width={"100%"} height={200} sx={{ borderRadius:2, alignContent:"center", alignItems:"center", justifyContent:"center", justifyItems:"center", bgcolor: "white", mt:5, mb:5 }}> 
                <Typography fontWeight={"bold"} color={colorCR5} fontSize={"1rem"}> 
                    Nenhum veículo adicionado 
                </Typography> 
                <Typography fontWeight={400} color={colorCR5} fontSize={"1rem"}> 
                    Comece selecionando os veículos ao lado. 
                </Typography> 
            </Box>
            ) : (
                <Stack spacing={2} width="100%">
                {veiculosSelecionados.map((veiculo) => (
                    <Box
                    key={veiculo.id}
                    display="flex"
                    gap={2}
                    sx={{
                        borderRadius: 3,
                        bgcolor:"white",
                        border: "1px solid rgba(0,0,0,0.08)",
                    }}
                    >
                    {/* IMAGEM */}
                    <Box
                        component="img"
                        src ={veiculo.url_img?.includes("veiculos")? veiculo.url_img 
                            : veiculo.url_img?.includes("hmlv2api")? veiculo.url_img :
                            veiculo.url_img?.includes("avaliadordigital")? veiculo.url_img 
                            :`https://www.canaldorepasse.com.br/anuncios/fotos/${veiculo.id_anuncio}/${veiculo.url_img}`}
                        alt={veiculo.modelo}
                        sx={{
                        width: 100,
                        height: 84,
                        borderRadius: 1,
                        objectFit: "cover",
                        bgcolor: "#f5f5f5",
                        }}
                    />

                    {/* TEXTO + AÇÃO */}
                   <Stack display={"flex"} flexDirection={"row"} justifyContent={"space-between"} width={"100%"} flexGrow={1}>
                     <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="space-around"
                        gap={0.5}
                    >
                        <Typography fontWeight={500} fontSize="0.95rem">
                        {veiculo.modelo ?? ""}
                        </Typography>

                        <Typography
                        fontSize="0.8rem"
                        color={colorPrimary}
                        fontWeight={600}
                        sx={{
                            cursor: "pointer",
                            width: "fit-content",
                            "&:hover": {
                            textDecoration: "underline",
                            },
                        }}
                        onClick={() =>
                            setVeiculosSelecionados((prev) =>
                            prev.filter((v) => v.id !== veiculo.id)
                            )
                        }
                        >
                        Remover do pacote
                        </Typography>
                    </Box>
                        <Box
                            onClick={() =>{
                            setSelectedAdId(veiculo.id);
                            }}
                            sx={{
                            width: 32,
                            height: 32,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 1,
                            cursor: "pointer",
                            mr:2,
                            mt:1,
                            transition: "0.25s ease",
                            "&:hover": {
                            transform: "translateY(-1px)",
                            },
                            }}>
                            <Eye size={24} />
                        </Box>
                   </Stack>
                </Box>
                ))}
                </Stack>
            )}
            </Box>
             {/*Container a direita de veículos a selecionar */}
            <Box display={"flex"} minHeight={400} maxHeight={600} flexDirection={"column"} gap={0}>
                    <Typography fontSize={"1rem"} color={colorSubText} fontWeight={400}>
                        {selectedCompany ? "Veículos disponíveis para seleção" : "Selecione a concessionária anunciante para carregar os veículos disponíveis"}
                    </Typography>
                    <Stack display={"flex"} flexDirection={"row"} width={"100%"} mt={2} gap={2} mb={3}>
                        <Typography fontWeight={400} fontSize={"1rem"} flex={3}>
                            Selecione um veículo já cadastrado no sistema - na lista abaixo - ou cadastre um novo veículo.
                        </Typography>
                        <NewVehicleBox
                            colorPrimary={colorPrimary}
                            onClick={handleNewVehicle}
                        />
                    </Stack>
                    <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-end"
                    width="100%"
                    gap={5}
                    >
                    <TextField
                        sx={{ ...textFieldStyle, flex: 3 }}
                        fullWidth
                        placeholder="Buscar por modelo.."
                        onChange={(e) => setSearch(e.target.value)}
                    />

                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography fontSize="1rem">
                        {start}-{end} de {veiculosFiltrados.length}
                        </Typography>

                        <Box
                        sx={{
                            cursor: page > 0 ? "pointer" : "not-allowed",
                            opacity: page > 0 ? 1 : 0.4,
                        }}
                        onClick={() => page > 0 && setPage(p => p - 1)}
                        >
                        {<ChevronLeft color={page >0? colorPrimary: undefined}/>}
                        </Box>

                        <Box
                        sx={{
                            cursor: page < totalPages - 1 ? "pointer" : "not-allowed",
                            opacity: page < totalPages - 1 ? 1 : 0.4,
                        }}
                        onClick={() =>
                            page < totalPages - 1 && setPage(p => p + 1)
                        }
                        >
                         {<ChevronRight color={page <totalPages - 1 ? colorPrimary: undefined}/>}
                        </Box>
                    </Stack>
                    </Stack>
                     <Divider sx={{ width: "100%", my: 1, borderBottomWidth: 2, mt:3 }} />
                    <TableContainer
                    sx={{
                    maxHeight: "100%",
                    }}
                    >
                    <Table
                    sx={{
                    bgcolor: "transparent",
                    borderCollapse: "separate",
                    borderSpacing: "0 8px",
                    }}
                    >
                    {/* HEADER */}
                    <TableHead>
                    <TableRow>
                    {["Seleção", "Veículo", "Status", "Ação"].map(
                    (col) => (
                    <TableCell
                    key={col}
                    sx={{
                    backgroundColor: "transparent",
                    color: "black",
                    fontSize: "1rem",
                    fontWeight: 600,
                    textTransform: "lowercase",
                    }}
                    >
                    {col}
                    </TableCell>
                    )
                    )}
                    </TableRow>
                    </TableHead>
                    {/* BODY */}
                    <TableBody>
                    {veiculosPaginados.map((row, index) => (
                    <TableRow
                    key={`${row.id}/${index}`}
                    sx={{
                        alignContent:"center",
                        justifyContent:"center",
                        alignItems:"center",
                        justifyItems:"center",
                        backgroundColor: "rgba(255,255,255,0.02)",
                        transition: "all 0.25s ease",
                    }}
                    >
                    <TableCell><Checkbox sx={{
                        "&.Mui-checked": {
                    color: theme.colors.primary.medium,
                    },
                    }} checked={isSelecionado(row.id)} onChange={() => toggleSelecionado(row)} /> </TableCell>
                    <TableCell sx={cellStyle}>{row.marca} - {row.modelo}.<br />Placa:{row.placa}</TableCell>
                    <TableCell sx={cellStyle}>
                    <Box
                    sx={{
                    width: 80,
                    height: 22,
                    borderRadius: 10,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "0.7rem",
                    fontWeight: 600,
                    color:  colorNegative,
                    bgcolor: colorBgNegative ,
                    }}
                    >
                    {row.status}
                    </Box>
                    </TableCell>
                    <TableCell sx={cellStyle}> <Stack direction="row" spacing={1} justifyContent="start" alignItems="start" > 
                    {/*Visualizar*/} 
                    <Box
                    onClick={() =>{
                   setSelectedAdId(row.id);
                    }}
                    sx={{
                    width: 32,
                    height: 32,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 1,
                    cursor: "pointer",
                    transition: "0.25s ease",
                    "&:hover": {
                    transform: "translateY(-1px)",
                    },
                    }}>
                    <Eye size={18} />
                    </Box>
                    </Stack> 
                    </TableCell>
                    </TableRow>
                    ))}
                    </TableBody>
                    </Table>
                    </TableContainer>
            </Box>
            </Box>
             <Divider sx={{ width: "100%", my: 2, borderBottomWidth: 2 }} />
        <form onSubmit={handleSubmit(onSubmitSalvar)}>

            <Box
            display="grid"
            gridTemplateColumns="repeat(2, 1fr)"
            gap={4}
            width="100%"
            >
            {/* leilao*/}
            <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Stack display={"flex"} flexDirection={"row"} gap={1} alignContent={"flex-start"} justifyContent={"flex-start"} justifyItems={"flex-start"} alignItems={"flex-start"} mt={2}>
                <Typography
                    fontWeight="bold"
                    fontSize="1.3rem"
                    color="black"
                >
                    Leilão
                </Typography>
                <IconInfo  title="Infor" icon={<Info size={20}/>}/>
            </Stack>
            <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2 }} />
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
            >
                <Typography fontWeight={400} width="400px">
                Ativar Leilão
                </Typography>

                <Switch
                checked={isLeilao}
                onChange={(e) => setLeilao(e.target.checked)}
                color="primary"
                />
            </Stack>
            <AutoCompleteField
            name="id_concessionaria_anunciante"
            control={control}
            errors={errors}
            options={companies ?? []}
            />
            {isLeilao && (
                <TextFieldController
                control={control}
                errors={errors}
                name="data_finalizacao_leilao"
                label=""
                title="Data de finalização do Leilão"
                placeholder="00/00/0000"
                required
                width="400px"
                type="date"
                />
            )}
            { isLeilao && (
            <TextFieldController
                control={control}
                errors={errors}
                name="horario_finalizacao_leilao"
                label="Horário"
                title="Horário de finalização do Leilão"
                placeholder="00:00"
                required
                type="time"
            />
            )}
            </Box>
            {/* VALORES*/}
            <Box display={"flex"} flexDirection={"column"} gap={2}>
            <Typography
                fontWeight="bold"
                fontSize="1.3rem"
                color="black"
                mt={2}
            >
                Valores *
            </Typography>
            <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2,}} />
            <Controller
            name="val_inicial"
            control={control}
            rules={{ required: "Valor inicial é obrigatório" }}
            render={({ field }) => (
            <TextFieldController
                control={control}
                errors={errors}
                name="val_inicial"
                label="Valor Inicial"
                title="Valor inicial do anúncio"
                placeholder="R$ 60.000,00"
                required
                mask={maskCurrencyBRL}
            />
            )}/>
            <Controller
            name="val_compre_agora"
            control={control}
            rules={{ required: "Valor de compre agora é obrigatório" }}
            render={({ field }) => (
            <TextFieldController
                control={control}
                errors={errors}
                name="val_compre_agora"
                label="Valor Compre Agora"
                title="Valor de Compre Agora"
                placeholder="R$ 60.000,00"
                required
                mask={maskCurrencyBRL}
            />
            )}/>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={2}>
                <Stack display={"flex"} flexDirection={"row"} gap={1} alignContent={"flex-start"} justifyContent={"flex-start"} justifyItems={"flex-start"} alignItems={"flex-start"} mt={2}>
                <Typography
                    fontWeight="bold"
                    fontSize="1.3rem"
                    color="black"
                >
                    Data e hora de término do anúncio
                </Typography>
                <IconInfo  title="Infor" icon={<Info size={20}/>}/>
                </Stack>
                    <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2 }} />
                        <Controller
                        name="data_finalizacao_anuncio"
                        control={control}
                        rules={{ required: "Data é obrigatório" }}
                        render={({ field }) => (
                        <TextFieldController
                        control={control}
                        errors={errors}
                        name="data_finalizacao_anuncio"
                        label=""
                        title="Data de finalização do Anúncio"
                        placeholder="00/00/0000"
                        required
                        width="400px"
                        type="date"
                        />
                        )}/>
                        <Controller
                        name="horario_finalizacao_anuncio"
                        control={control}
                        rules={{ required: "Horário é obrigatório" }}
                        render={({ field }) => (
                        <TextFieldController
                            control={control}
                            name="horario_finalizacao_anuncio"
                            label="Horário"
                            title="Horário de finalização do Anúncio"
                            placeholder="00:00"
                            required
                        type="time"
                        />
                        )}/>
            </Box>
            <Box display={"flex"} flexDirection={"column"} gap={2} mt={2}>
                <Typography
                    fontWeight="bold"
                    fontSize="1.3rem"
                    color="black"
                >
                    Texto padrão
                </Typography>
                    <Divider sx={{ width: "100%", my:0, borderBottomWidth: 2 }} />
                <Controller
                        name="texto_padrao"
                        control={control}
                        rules={{ required: "Observação é obrigatório" }}
                        render={({ field }) => (
                        <TextField
                        {...field}
                        sx={textFieldStyle}
                        fullWidth
                        multiline
                        rows={4.05}
                        label=""
                        placeholder="Detalhes sobre a oferta do anúncio, contatos e etc..."
                        error={!!errors?.texto_padrao}
                        // helperText={errors?.placa?.message}
                        />
                        )}
                    />
            </Box>
            </Box>
                <Stack
                direction="row"
                justifyContent="flex-end"
                mt={4}
                gap={2}
                >
                <Button
                    variant='text'
                    onClick={() => {
                    navigate("/anuncios");
                    }}
                    type='button'
                >
                <ArrowBack fontSize='medium' />
                    <span>Voltar</span>
                </Button>
                {status !== '1'? 
                <SubmitButton
                type="submit"
                disabled={loading}
                /> : undefined    
                }
                {isEdit && (status ==='1' || status === '2') && ativo ==='1'? (
                <Button 
                fitContent={true}
                variant="large"
                type="button"
                onClick={handleSubmit(
                submitRenewAnuncioCombo,
                )}
                >
                <SaveOutlined fontSize='medium' />
                Renovar
                </Button>
                ) : undefined}
                {adId && (status === "0" || status === "2") && ativo === '0'? (
                <Button 
                fitContent={true}
                variant="large"
                type='button'
                onClick={submitPublicaCombo}
                >
                <SaveOutlined fontSize='medium' />
                Publicar
                </Button>
                ): undefined}
                {adId && ativo === '1' && status !=='1'? (
                <Button
                fitContent={true}
                variant='largeRed'
                type="button"
                onClick={submitDesativaCombo}
                >
                <DeleteOutlined fontSize='medium' />
                Desativar
                </Button>
                ) : undefined}
                </Stack>
        </form>
        </Box>
            </>
    );
}